// src/auth/context/jwt/access-token-ref.ts
export const accessTokenRef = { current: null as string | null };